import { render, staticRenderFns } from "./userPoptip.vue?vue&type=template&id=37ff8b5c&scoped=true&"
import script from "./userPoptip.vue?vue&type=script&lang=js&"
export * from "./userPoptip.vue?vue&type=script&lang=js&"
import style0 from "./userPoptip.vue?vue&type=style&index=0&id=37ff8b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff8b5c",
  null
  
)

export default component.exports